import * as React from 'react'

const SvgDownloadOneIcon = ({ stroke = '#98A2B3', strokeWidth = '1.5' }) => (
  <svg
    width="16"
    height="20"
    viewBox="0 0 16 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    stroke={stroke}
    strokeWidth={strokeWidth}
  >
    <path
      d="M9.66732 1.89124V5.33335C9.66732 5.80006 9.66732 6.03342 9.75815 6.21168C9.83804 6.36848 9.96552 6.49596 10.1223 6.57586C10.3006 6.66669 10.5339 6.66669 11.0007 6.66669H14.4428M5.50065 12.5L8.00065 15M8.00065 15L10.5007 12.5M8.00065 15L8.00065 9.99996M9.66732 1.66663H5.33398C3.93385 1.66663 3.23379 1.66663 2.69901 1.93911C2.2286 2.17879 1.84615 2.56124 1.60647 3.03165C1.33398 3.56643 1.33398 4.26649 1.33398 5.66663V14.3333C1.33398 15.7334 1.33398 16.4335 1.60647 16.9683C1.84615 17.4387 2.2286 17.8211 2.69901 18.0608C3.23379 18.3333 3.93385 18.3333 5.33398 18.3333H10.6673C12.0674 18.3333 12.7675 18.3333 13.3023 18.0608C13.7727 17.8211 14.1552 17.4387 14.3948 16.9683C14.6673 16.4335 14.6673 15.7334 14.6673 14.3333V6.66663L9.66732 1.66663Z"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default SvgDownloadOneIcon
